exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column}:host h4{font-size:20px;margin-top:-1rem;text-transform:uppercase}:host h4 em.fa{margin-right:1rem}.container-inline{display:flex;justify-content:space-around}.banner-subtitle{margin-top:0;margin-bottom:2rem;overflow-wrap:break-word;display:inline;line-height:1.4rem;font-family:Open sans,sans-serif;font-size:1.2rem;font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/requete/requete-title/requete-title.component.scss
// module id = 720
// module chunks = 0